<template>
  <ml-input v-if="readonly" v-model="data" style="color: red" readonly class="w-full flex-1" />
  <div v-else-if="multiple">
    <multiselect :options="disasterList" v-model="data" :multiple="true" placeholder="" />
    <ml-input v-if="isCustomData" v-model="customData" class="mt-2 w-full" placeholder="직접입력" />
  </div>
  <div v-else>
    <vs-select v-model="data" autocomplete :disabled="disabled || readonly" class="w-full red-text disaster">
      <vs-select-item v-for="disaster in disasterList" :key="disaster" :value="disaster" :text="disaster" />
    </vs-select>
    <ml-input v-if="isCustomData" v-model="customData" @focusout="focusout" class="mt-2 w-full" placeholder="직접입력" />
  </div>
</template>

<script>
import { disasters } from "@/util/DisasterDataUtil.js";
import Multiselect from "vue-multiselect";
export default {
  name: "DisasterClassSelector",
  components: {
    Multiselect,
  },
  props: {
    value: String | Array,
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
    customDisasterList: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    isCustomData() {
      return this.data && this.data.indexOf("직접입력") >= 0;
    },
  },
  data() {
    return {
      disasterList: disasters,
      data: this.value,
      customData: "",
      selected: "",
    };
  },
  watch: {
    value(value) {
      if (this.multiple) {
        const list = [];
        if (value && value.length > 0) {
          for (const data of value) {
            if (this.disasterList.indexOf(data) === -1) {
              list.push("직접입력");
              this.customData = data;
            } else {
              list.push(data);
            }
          }
        }
        if (JSON.stringify(this.data) !== JSON.stringify(list)) {
          this.data = list;
        }
      } else {
        this.data = value;
      }
    },
    customData() {
      this.emitInput();
    },
    data(/*value*/) {
      this.emitInput();
    },
  },
  mounted() {
    if (this.customDisasterList.length > 0) {
      this.disasterList = this.customDisasterList;
    }
  },
  methods: {
    focusout() {
      this.$emit("input", this.customData);
    },
    emitInput() {
      if (!this.multiple) {
        // if (this.data === "직접입력") {
        //   this.$emit("input", this.customData);
        // } else {
        //   this.$emit("input", this.data);
        // }
        this.$emit("input", this.data);
      } else {
        const list = [];
        if (this.data && this.data.length > 0) {
          for (const data of this.data) {
            if (data === "직접입력") {
              list.push(this.customData);
            } else {
              list.push(data);
            }
          }
        }
        this.$emit("input", list);
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.red-text.disaster input {
  color: red;
}
</style>
<style lang="scss">
.multiselect {
  .multiselect__tags {
    .multiselect__tag {
      background-color: rgba(var(--vs-secondary), 1) !important;
    }
    .multiselect__tag-icon::after {
      color: rgb(30, 13, 97);
    }
    border-color: #cdcdcd !important;
  }
}
</style>
